import { ThemeDefinition } from "vuetify";

// Colors from scss/variables.scss

const theme: ThemeDefinition = {
    colors: {
        primary: "#1b69d4",
        secondary: "#666666",
        error: "#dc3545",
        success: "#008b29",
        warning: "#fccc02",
        "on-primary": "#FFFFFF",
        "on-warning": "#FFFFFF"
    }
};

export default theme;
